import { render, staticRenderFns } from "./rightProvince.vue?vue&type=template&id=54552ac4&scoped=true"
import script from "./rightProvince.vue?vue&type=script&lang=js"
export * from "./rightProvince.vue?vue&type=script&lang=js"
import style0 from "./rightProvince.vue?vue&type=style&index=0&id=54552ac4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54552ac4",
  null
  
)

export default component.exports